import {useEffect} from 'react'
import {useQuery} from '@tanstack/react-query'
import {getOnboardingSnapshot} from '@api/onboarding.js'
import {checkAuth} from '@utils/auth.js'
import useOnboardingStore from '@stores/useOnboardingStore.js'

export default function useOnboardingBootstrap() {
  const isAuth = checkAuth()
  const refreshTick = useOnboardingStore(state => state.refreshTick)
  const clear = useOnboardingStore(state => state.clear)
  const setLoading = useOnboardingStore(state => state.setLoading)
  const setSnapshot = useOnboardingStore(state => state.setSnapshot)
  const setError = useOnboardingStore(state => state.setError)

  const query = useQuery({
    queryKey: ['me', 'onboarding', isAuth ? 'auth' : 'guest', refreshTick],
    queryFn: async () => {
      if (!isAuth) return null
      return getOnboardingSnapshot()
    },
  })

  useEffect(() => {
    if (isAuth) return
    clear()
  }, [clear, isAuth])

  useEffect(() => {
    if (!isAuth) return
    setLoading(Boolean(query.isLoading || query.isFetching))
  }, [isAuth, query.isFetching, query.isLoading, setLoading])

  useEffect(() => {
    if (!isAuth) return
    if (!query.error) return
    setError(query.error?.message || 'Failed to load onboarding snapshot')
  }, [isAuth, query.error, setError])

  useEffect(() => {
    if (!isAuth) return
    if (!query.data || typeof query.data !== 'object') return
    setSnapshot(query.data)
  }, [isAuth, query.data, setSnapshot])
}
